import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutImportFileExceptionTable extends Layout {
    sourceImportFileException: DataSource;
    tableExceptions: Table;
}
